import { render, staticRenderFns } from "./UserTicketDetails.vue?vue&type=template&id=4a82c2c2&"
import script from "./UserTicketDetails.vue?vue&type=script&lang=js&"
export * from "./UserTicketDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports